import { useCallback, useMemo } from 'react'

import { usePatientQueryParams } from './usePatientsQueryParams'
import { usePatients } from '../api/searchPatients'

export const PATIENTS_PER_PAGE = 50

export const usePatientPagination = () => {
  const { queryParamObject, setQuery } = usePatientQueryParams()

  const currentPage = queryParamObject.page

  const { data } = usePatients({})

  const totalCount = data?.totalCount ?? 0

  const totalPageCount = Math.ceil(totalCount / PATIENTS_PER_PAGE)

  const hasPrevPage = currentPage > 1
  const hasNextPage = currentPage < totalPageCount

  const currentRange = useMemo(() => {
    const currentOffset = PATIENTS_PER_PAGE * (currentPage - 1)
    const currentLimit = PATIENTS_PER_PAGE * currentPage

    const start = totalCount === 0 ? 0 : currentOffset + 1
    const end = currentLimit < totalCount ? currentLimit : totalCount
    return `${start} - ${end}`
  }, [currentPage, totalCount])

  const handleClickFirstPage = useCallback(() => {
    if (currentPage === 1) return
    setQuery({ type: 'pagination', value: 1 })
  }, [setQuery, currentPage])

  const handleClickPrevPage = useCallback(() => {
    if (!hasPrevPage) return
    setQuery({ type: 'pagination', value: currentPage - 1 })
  }, [setQuery, currentPage, hasPrevPage])

  const handleClickNextPage = useCallback(() => {
    if (!hasNextPage) return
    setQuery({ type: 'pagination', value: currentPage + 1 })
  }, [setQuery, currentPage, hasNextPage])

  const handleClickLastPage = useCallback(() => {
    if (currentPage === totalPageCount) return
    setQuery({ type: 'pagination', value: totalPageCount })
  }, [setQuery, currentPage, totalPageCount])

  return {
    totalCount,
    totalPageCount,
    currentPage,
    rangeString: currentRange,
    hasFirstPage: hasPrevPage,
    hasPrevPage,
    hasNextPage,
    hasLastPage: hasNextPage,
    handleClickFirstPage,
    handleClickPrevPage,
    handleClickNextPage,
    handleClickLastPage,
  }
}
